import { GraphicalDashboardCard } from "../../components/dashboard/GraphicalDashboardCard";
import React from "react";
import { DashboardData } from "../../types/dashboardData";
import { Box, Typography } from "@mui/material";
import { useCustomTranslation } from "../../provider/useCustomTranslation";

export function NewsCard(props: { data: DashboardData }) {
  const { data } = props;
  const { t } = useCustomTranslation();
  return (
    <GraphicalDashboardCard
      gridProps={{ xs: 12, md: 6 }}
      title={t("common.news")}
      resource={"news"}
    >
      <Box
        display={"flex"}
        flexDirection={"row"}
        marginX={"auto"}
        marginY={"auto"}
        gap={4}
      >
        <Box display={"flex"} flexDirection={"column"} alignItems={"center"}>
          <Typography
            variant={"h2"}
            textAlign={"center"}
            color={"#4832BB"}
            fontWeight={700}
          >
            {data.news.publishedNews}
          </Typography>
          <Typography
            variant={"h6"}
            textAlign={"center"}
            color={"#4832BB"}
            fontWeight={300}
          >
            {t("pages.dashboard.newsStatus.published")}
          </Typography>
        </Box>
        <Box display={"flex"} flexDirection={"column"} alignItems={"center"}>
          <Typography
            variant={"h2"}
            textAlign={"center"}
            color={"#FD6A1C"}
            fontWeight={700}
          >
            {data.news.upcomingNews}
          </Typography>
          <Typography
            variant={"h6"}
            textAlign={"center"}
            color={"#FD6A1C"}
            fontWeight={300}
          >
            {t("pages.dashboard.newsStatus.upcoming")}
          </Typography>
        </Box>
      </Box>
    </GraphicalDashboardCard>
  );
}
